var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_497_375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_497_375)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -1,
    width: 21,
    height: 21,
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_497_375",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_497_375",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAOXSURBVFiFrdddiJZFFAfw31m3/Ihy2RQK8qKbwIpcDKJCbKPtO4qEtgihqBCKLupGKIuMoJvKGwUJhIKEikDLUqgMtyj7IGJV0gu1wAstkc1UpGTxdPHMW4/vvu++2+4eGHhm5syc/5zzP2fmkZnaNXTjLfyFnEL7Dr2tbHQbX5bhfjyMkQ667eRRPILtETGQmefs0wnAlRjOzE2TNC4i+rGrdMeAaAkgImZgIRZ02HwWrm8zfTwzhxvfKm9uHwOiKeY34Ruc9l/8RvEOFrbgyHLt434MPViNoaLfi59K681MXeUkXRHxGj4rk3cXIGvwAOZiV0QM1o+YmRszM9q0eZl5vEl/BAOluz0iehshWKkiyu2ZOVRAjeJkZm7G5oh4Ahsj4kxmflh0BvBCmxCMqAh4Fn0RMVSb68IibOuOiD68jGUN460kMzdExBVYExHbMvMMDqDdmhGcwrqa0boMl0Nbh60t4juE1U1jM3ECy8erHxNp6Ed24VrsaHfyJi/8jc/LmmmTE7intLU1hJu0Z/gnRec9FdOXqmLdqSIeQ0/dA4E9eBOH8QEuz8xDEdGDvhaAV+HXzFwRET2ZeTwiurDE2Dg3y7+1oRSoHd2qtLsOz+JPPI2VJYWG6qsjIvAutpShayLi6+KF/gkAGImI3Zl5tjHQjc14H6/jKVWq3Yr12FBXxkO4oIBQTj2MyyYKAG+rwl5JicdG7MZ8lTe24SiW1jhxFU5i1VQzoM6BRmcuvi1GBzGnpnghnlOV57WIaQdQBmbgRZxR1f89OKhi9y94fIoG56jK8HktATQp3qgi4xf4Ed1TNH5R8e4o9hau9CPHXMeZeRo7sTMi5qE/M0c7kKuT3FVCeS+2YnFjohNrx5WIGIyIryLipZKi7eQoZqnSd58q9acGICJ6VSl1SEXSO9roLSh6W1QeWNRcByYr8zG71r+0hfH5qrtjPwbLXXKOTMoDpfS+it9xNX7DioiYWdOZi09V1fW+VsYnDUBVJW/GLZnZhxtU78f1xfhsfIzzcWdmnmq30YRDEBGL8QouUT1YBzLzZ8jMIxGxDF8WvV5Vyi3Jpmd4s/wfD6xXPUguxkeZubM+mZnf4wdV4TqGA5l5uNOmkw3BoTbjR2rff0xko/8D4Ek0XkRvtNF5XsX4/eW7o0yYA5nZeK6Pp3MQD050T6ZYCadDOnlgL54pDJ/sz2k7eQz7Ot1i0/V73qrtxW3/ADQNBVXvZObSAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.6080d32990e4d32f064077c776b85e43.svg";
export { ForwardRef as ReactComponent };